import { injectService } from '@/inversify.config';
import { I18nService } from '@/services/i18n-service';
import _ from 'lodash';
// @ts-ignore
import { EmailInput as PtEmailInput } from 'patsnap-biz';
import { getGroupsApi } from '@cores/apis/workspace_api/group';
export class CustomGroupInputService extends PtEmailInput.EmailInputService {
    constructor(_options) {
        super();
        this._options = _options;
        this._i18nService = injectService(I18nService);
        this.initSelectedEmail = '';
        this.placeholder = this._options.placeholder;
        this.nodataLabel = this._options.noDataLabel;
        this._key = _.uniqueId('emailInputService_');
        this.companyMode = true;
        this.isAlwaysShowOnFocus = this._options.autoFocus;
    }
    setSelectedEmail(newSelected, ...args) {
        super.setSelectedEmail(newSelected, ...args);
        this._options.postSelectCallback(newSelected.length ? newSelected[0] : undefined);
    }
    getEmailList(keywords) {
        return this._autoCompleteApi(keywords);
    }
    getDefaultList() {
        return this._autoCompleteApi();
    }
    _autoCompleteApi(keyword = '') {
        return getGroupsApi({ name: keyword }).then(data => {
            const result = data.records.map(this._convertGroupOption.bind(this));
            return result;
        });
    }
    _convertGroupOption(data) {
        return {
            user_id: data.id,
            user_email: data.name,
            email: this._getEmailDisplay(data),
            nickname: data.name,
            avatar_color: data.avatar_color,
            avatar_pattern: data.avatar_pattern,
            avatar: data.avatar,
            mobile_number: this._getMobileNumberDisplay(data),
        };
    }
    _getEmailDisplay(data) {
        const total = this._i18nService.t('shareUserOrGroup.team.info.people', { count: data.total });
        return total;
    }
    _getMobileNumberDisplay(data) {
        const policy = data.policy === 'PRIVATE'
            ? this._i18nService.t('shareUserOrGroup.team.info.private')
            : this._i18nService.t('shareUserOrGroup.team.info.public');
        return policy;
    }
}
